<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  // import Jwtdecode from 'jwt-decode'
  // Loading some plugin css asynchronously
  import('sweetalert2/dist/sweetalert2.css')
  import('vue-notifyjs/themes/default.css')
  export default {
    beforeCreate: function () {
      this.$log.debug('App.beforeCreate ' + this.$route.query.id)
      if (this.$route.query.id !== undefined && this.$route.query.id != null && parseInt(this.$route.query.id) > 0) {
        window.sessionStorage.setItem('bgbackend_betgameid', this.$route.query.id)
        this.$store.dispatch('setBetgame', parseInt(this.$route.query.id))
      } else {
        if (document.domain !== 'localhost') {
          const domain = document.domain
          if (domain === 'backend.boyens.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1')
            this.$store.dispatch('setBetgame', 1)
          } else if (domain === 'backend.snh.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '2')
            this.$store.dispatch('setBetgame', 2)
          } else if (domain === 'backend.pz.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '12')
            this.$store.dispatch('setBetgame', 12)
          } else if (domain === 'backend.fubanews.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '4')
            this.$store.dispatch('setBetgame', 4)
          } else if (domain === 'backend.flarena.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '5')
            this.$store.dispatch('setBetgame', 5)
          } else if (domain === 'backend.elfer.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '6')
            this.$store.dispatch('setBetgame', 6)
          } else if (domain === 'backend.mm.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '7')
            this.$store.dispatch('setBetgame', 7)
          } else if (domain === 'backend.fussifreunde.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1302')
            this.$store.dispatch('setBetgame', 1302)
          } else if (domain === 'backend.ovb24.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1411')
            this.$store.dispatch('setBetgame', 1411)
          } else if (domain === 'backend.del2.ovb24.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1460')
            this.$store.dispatch('setBetgame', 1460)
          } else if (domain === 'backend.reviersport.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1608')
            this.$store.dispatch('setBetgame', 1608)
          } else if (domain === 'backend.wm2022.reviersport.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1604')
            this.$store.dispatch('setBetgame', 1604)
          } else if (domain === 'backend.ez.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1902')
            this.$store.dispatch('setBetgame', 1902)
          } else if (domain === 'backend.nwz.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '1702')
            this.$store.dispatch('setBetgame', 1702)
          } else if (domain === 'backend.polygon.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '3004')
            this.$store.dispatch('setBetgame', 3004)
          } else if (domain === 'backend.bl1.funke.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '4001')
            this.$store.dispatch('setBetgame', 4001)
          } else if (domain === 'backend.bl2.funke.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '4002')
            this.$store.dispatch('setBetgame', 4002)
          } else if (domain === 'backend.em.funke.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '4003')
            this.$store.dispatch('setBetgame', 4003)
          } else if (domain === 'backend.fn.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '5001')
            this.$store.dispatch('setBetgame', 5001)
          } else if (domain === 'backend.sb.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_betgameid', '7001')
            this.$store.dispatch('setBetgame', 7001)
          }
        }
      }
      if (this.$route.query.api !== undefined && this.$route.query.api != null && this.$route.query.api.length > 0) {
        window.sessionStorage.setItem('bgbackend_apiUrl', 'https://' + this.$route.query.api)
      } else {
        if (document.domain !== 'localhost') {
          window.sessionStorage.setItem('bgbackend_apiUrl', 'https://' + document.domain.replace('backend.', ''))
          if (document.domain === 'backend.del2.ovb24.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_apiUrl', 'https://del2.ovb24.teamtip.net')
          } else if (document.domain === 'backend.wm2022.reviersport.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_apiUrl', 'https://reviersport.teamtip.net')
          } else if (document.domain === 'backend.bl1.funke.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_apiUrl', 'https://funke.teamtip.net')
          } else if (document.domain === 'backend.bl2.funke.teamtip.net') {
            window.sessionStorage.setItem('bgbackend_apiUrl', 'https://funke.teamtip.net')
          }
        }
      }
    },
    created () {
      this.$log.debug('App.created')
    },
    mounted () {
      this.$log.debug('App.mounted currentRoute ' + this.$router.currentRoute.path + ' --- ' + this.$route.params.id)
      // if (!this.$store.state.apiUrl) {
      this.$store.dispatch('setApiUrl', window.sessionStorage.getItem('bgbackend_apiUrl'))
      // }
      if (!this.$store.state.betgame || this.$store.state.betgame === -1) {
        const bgid = window.sessionStorage.getItem('bgbackend_betgameid')
        if (bgid !== undefined && bgid != null && parseInt(bgid) > 0) {
          this.$store.dispatch('setBetgame', parseInt(bgid))
        } else {
          this.$log.debug('App.mounted betgameId not set')
          const that = this
          this.$store.dispatch('logout').then(() => {
            that.$router.push('/login')
          })
        }
      }
      // this.$log.debug('token ' + this.$store.state.token + ' --- ' + this.$store.state.betgame)
      if (this.$store.state.token) {
        window.sessionStorage.setItem('bgbackend_token', this.$store.state.token)
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame)
        const r = this.$cookies.get('lastRoute')
        if (r !== undefined && r !== null && r.length >= 0 && r !== 'undefined') {
          this.$router.push({ name: r }).catch(err => {
            this.$log.error(err)
          })
        }
      }
    },
    watch: {
      $route (to, from) {
        this.$log.debug(from.path + ' --- ' + to.patch + ' --- ' + this.$router.currentRoute.path)
      }
    }
  }
</script>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue